/**
 * Returns the best landing route for a user based on their permissions.
 * Priority order: if a user has permissions for multiple sections, the first
 * match wins. Add new entries here when creating new feature areas.
 */
const ROUTE_PRIORITY = [
  { route: '/admin/dashboard', perms: ['applications.view', 'intakes.view', 'reports.view', 'settings.view'] },
  { route: '/admin/cohorts',   perms: ['academy.manage'] },
  { route: '/admin/users',     perms: ['users.view'] },
  { route: '/admin/roles',     perms: ['roles.view'] },
];

export const getHomeRoute = (userData) => {
  if (!userData || userData.is_super_admin) return '/admin/dashboard';
  const perms = new Set(userData.permissions || []);
  for (const { route, perms: required } of ROUTE_PRIORITY) {
    if (required.some(p => perms.has(p))) return route;
  }
  return '/admin/dashboard';
};
